<template>
  <div class="mdl-layout mdl-js-layout">
    <div class="mdl-card mdl-shadow--2dp">
      <div class="mdl-card__media">
        <img src="./gt-aim.png" alt="GT AIM Logo">
      </div>
      <div class="mdl-card__title">
        <h1 class="mdl-card__title-text">GT AIM</h1>
      </div>
      <div class="mdl-card__content">
        <button id="google-signin" class="signin-button mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored">{{ signinText }}</button>
        <!-- <form v-on:submit.prevent="login">
          <div id="google-signin" class="signin-button"></div>
        </form> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      signinText: 'Iniciar Sesión'
    }
  },
  methods: {
    onSuccess (googleUser) {
      // return googleUser.disconnect()
      const self = this
      self.$loading.show()
      let basicProfile = googleUser.getBasicProfile(),
          authResponse = googleUser.getAuthResponse(),
          user = {
            gid: basicProfile.getId(),
            name: basicProfile.getName(),
            givenName: basicProfile.getGivenName(),
            familyName: basicProfile.getFamilyName(),
            email: basicProfile.getEmail(),
            avatar: basicProfile.getImageUrl(),
            // accessToken: authResponse.access_token,
            idToken: authResponse.id_token
          }

      // Callback called when tags have finished sending
      self.$http.defaults.headers.common['Authorization'] = user.email // user.idToken
      self.$http.get('/login?email=' + user.email + '&avatar=' + user.avatar)
        .then( response => {
          let data = response.data

          if (data.success.match(/1/)) {
            user.id = data.response.id
            user.role = data.response.role
            user.roleCode = data.response.roleCode

            // Save user on global and on idb.
            self.$user.data = user
            return self.$idb.keyVal.set('login', undefined, user)
              .then( () => {
                OneSignal.push(function() {
                  OneSignal.isPushNotificationsEnabled(function(isEnabled) {
                    if (isEnabled) {
                      console.log("Push notifications are enabled!")
                      OneSignal.sendTag('role', user.role)
                    } else {
                      self.$toast.show('Las notificaciones push no estan habilitadas.')
                      console.log("Push notifications are not enabled yet.")
                      OneSignal.registerForPushNotifications()
                      // self.$loading.hide()
                    }
                  })
                })

                // Send the user to Home page.
                self.$toast.show('Bienvenido ' + user.name + '.')
                self.$emit('viewChanged', 'Home')
                self.$loading.hide()
              })
              .catch( () => {
                self.$toast.show('Algo sucedió, porfavor vuelve a intentarlo.')
                self.$loading.hide()
              })
          }

          googleUser.disconnect()
          self.$loading.hide()
          return self.$toast.show(data.response)
        }).catch(() => {
          googleUser.disconnect()
          self.$loading.hide()
        })
    },
    onFailure (error) {
      this.$toast.show('¡Algo sucedió! Vuelve a intentar iniciar sesión, porfavor.')
    }
  },
  mounted () {
    const self = this
    self.$loading.show()
    self.$idb.keyVal.getAll('login').then(response => {
      self.$loading.hide()

      if (response.length > 0) {
        self.$user.data = response[0]
        return self.$emit('viewChanged', 'Home')
      }

      gapi.load('auth2', () => {
        gapi.auth2.init().then(googleAuth => {
          const googleSignInButton = document.querySelector('#google-signin')
          googleAuth.attachClickHandler(googleSignInButton, {},
            self.onSuccess, self.onFailure);
        })
      })

      /*gapi.signin2.render('google-signin', {
        'scope': 'profile email',
        'width': 240,
        'height': 40,
        'longtitle': true,
        'theme': 'light',
        'onsuccess': self.onSuccess,
        'onfailure': self.onFailure
      });*/
    })

    componentHandler.upgradeElement(this.$el)
  }
}
</script>

<style lang="css" scoped>
  .mdl-layout {
    background: url('bg-1.min.jpg') center / cover;
    opacity: 0.75;
  }

  .mdl-layout .mdl-card {
    margin: auto;
    opacity: 0.9;
  }

  .mdl-layout .mdl-card .mdl-card__media {
    height: 150px;
    background: #fff;
  }

  .mdl-layout .mdl-card .mdl-card__media img {
    display: block;
    max-width: 100%;
    height: 80%;
    margin: 20px auto;

    /*-webkit-transform: translateY(-15%);
      -ms-transform: translateY(-15%);
          transform: translateY(-15%);*/
  }

  .mdl-layout .mdl-card .mdl-card__title {
    padding: 0;
  }

  .mdl-layout .mdl-card .mdl-card__title .mdl-card__title-text {
    display: block;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
  }

  .mdl-layout .mdl-card .mdl-card__content {
    width: 100%;
    padding: 0 3rem;
  }

  .mdl-layout .mdl-card .mdl-card__content .signin-button {
    width: 100%;
    margin: 0.75rem auto 2rem;
  }

  .mdl-layout .mdl-card .mdl-card__content form div {
    width: 100%;
  }

  .mdl-layout .mdl-card .mdl-card__actions {
    text-align: center;
  }

  .mdl-layout .mdl-card .mdl-card__actions .mdl-button {
    text-transform: none;
  }
</style>


// WEBPACK FOOTER //
// index.vue?e1d98a62